const getters = {
  sidebar: state => state.app.sidebar,
  device: state => state.app.device,
  token: state => state.user.token,
  avatar: state => state.user.avatar,
  name: state => state.user.name,
  roles: state => state.user.roles,
  cqb: state => state.user.cqb,
  cqo: state => state.user.cqo,
  addRouters: state => state.permission.addRouters,
  routers: state => state.permission.routers,
  menuCodeSet: state => state.permission.menuCodeSet
}
export default getters



// WEBPACK FOOTER //
// ./src/store/getters.js